/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers')
    .controller('CustomerCtrl',
        ["$scope", "$dialog", "$rootScope", "$filter", "$log", "$route", "$timeout", "$sce", "Customer", "CustomerSrv", "CustomerData",
            "CustomerView", "BookingData", "SaleData", "GiftItemData", "CureItemData", "gettextCatalog", "LanguageManager", "PhoneFormat", "OptInOutView",
            "Constants", "LaunchDarklyFeatureFlagData","CookieFactory","SmsCampaignSrv", "Timers", "Images",
        function($scope, $dialog, $rootScope, $filter, $log, $route, $timeout, $sce, Customer, CustomerSrv, CustomerData,
            CustomerView, BookingData, SaleData, GiftItemData, CureItemData, gettextCatalog, LanguageManager, PhoneFormat,OptInOutView,
            Constants, LaunchDarklyFeatureFlagData, CookieFactory,SmsCampaignSrv, Timers, Images) {
        $scope.bookingStatusImage = Images.saleStatus;
        $scope.isSideBarCollapsed = false;
        $scope.smsCampaignsLoading = false;
        $scope.dd.view.display = {
            customerSubMode :1,
            fusionCustomersError : false
        };
        $scope.customerSubModes = {
            customerData: 1,
            customerSmsCampaign: 2,
            customerNotificationCampaign: 3,
            customerTrash: 4,
            configuration: 5
        };
        $scope.customerSortModes = {
            sortByName: 'lastName',
            sortByTotal: 'historyRealPaidPrice',
            sortByVisit: 'nbSoldSales'
        };
        $scope.cutomerTabNeedToOrder = true;
        $scope.customersSortValue = "lastName";
        $scope.customersOrderByReverse = false;
        $scope.customerFilterModes = {
            filterByBirthday: 'birthday',
            filterByManGender: 'M',
            filterByWomanGender: 'W',
            filterByChildGender: 'C'
        };
        $scope.customersFilterValue = "";
        $scope.myMargintop = 40;

        $scope.isAccessBackofficeCustomer = false;
        $scope.isAllCustomerViewsHistoryLoaded = false;
        let timers = [];

        $scope.fetchSmsCampaign = function() {
            $scope.smsCampaignsLoading = true;
            return SmsCampaignSrv.query(() => {
                SmsCampaignSrv.loadRef();
                $scope.smsCampaignsLoading = false;
                $scope.dd.view.loadSmsCampaignListView();
                $scope.loadAllCustomerViewsHistory();
            }, () => {
                $scope.smsCampaignsLoading = false;
            });
        };

        $scope.fetchNotificationCampaign = function() {
            $scope.dd.view.loadNotificationCampaignListViews();
            $scope.loadAllCustomerViewsHistory();
        };

        $scope.loadAllCustomerViewsHistory = function(callbackFunction) {
            if(!$scope.isAllCustomerViewsHistoryLoaded) {
                const timer = $timeout(function (){
                    for (let i = 0; i < $scope.dd.view.customersView.length; i++) {
                        let customerView = $scope.dd.view.customersView[i];
                        if (!customerView.isHistoryInit) {
                            customerView.initCustomerHistoryDatas(customerView.getModel())
                        }
                    }
                    $scope.isAllCustomerViewsHistoryLoaded = true;
                    if(callbackFunction !== undefined) {
                        callbackFunction();
                    }
                }, 300);

                timers.push(timer);
            }
            else {
                if(callbackFunction !== undefined) {
                    callbackFunction();
                }
            }
        };

        $scope.backofficeFrontendUrl =  '';

        $scope.onButtonClickSubModes = function(subMode) {
            if (this.isAccessBackofficeCustomer) {
                if (subMode === $scope.customerSubModes.customerData) {
                    this.navigateToNgApp({route: Constants.ngRoutings.customer.list});
                }
                else if (subMode === $scope.customerSubModes.customerTrash) {
                    this.navigateToNgApp({route: Constants.ngRoutings.customer.trash});
                }
            }

            $scope.dd.view.display.customerSubMode = subMode;
            if (subMode === $scope.customerSubModes.customerSmsCampaign) {
                $scope.isSideBarCollapsed = true;
                $scope.fetchSmsCampaign();
            } else if (subMode === $scope.customerSubModes.customerNotificationCampaign) {
                $scope.isSideBarCollapsed = true;
                $scope.fetchNotificationCampaign();
            } else {
                $scope.isSideBarCollapsed = false;
            }
        };

        $scope.isSubMode = function(subMode) {
            return $scope.dd.view.display.customerSubMode === subMode;
        };

        const goToDomainCalledDestroy = $rootScope.$on('goToDomainCalled', function(_) {
            if ($scope.dd.view && $scope.dd.view.display) {
                if ($scope.ad.sDm === 'customer' && $scope.dd.view) {
                    $scope.dd.view.customerFilterBirthday = false;
                    $scope.onChangeCustomerFilter($scope.customersFilterValue);
                }
            }
        });

        $scope.$watch('ad.sDm', function(){
            if ($scope.dd.view && $scope.dd.view.display) {
                if ($scope.ad.sDm === 'customer' && $scope.dd.view && $scope.dd.view.customersView) {
                    if($scope.dd.view.customerFilterBirthday) {
                        $scope.customersFilterValue = $scope.customerFilterModes.filterByBirthday;
                        $scope.dd.view.customerFilterBirthday = false;
                    }
                    $scope.onChangeCustomerFilter($scope.customersFilterValue);
                }
            }
        });

        $scope.$watch("ad.dataLoaded", function(loaded) {
            if (loaded) {
                $scope.isAccessBackofficeCustomer = LaunchDarklyFeatureFlagData.canAccessBackofficeCustomer;
                if ($scope.isAccessBackofficeCustomer && !$scope.backofficeFrontendUrl) {
                    $scope.backofficeFrontendUrl =  $sce.trustAsResourceUrl('/backoffice/' + $scope.ad.loggedUser.company.localeCode + '/');
                }
            }
        });

        $scope.updateManagerModeCookie = function () {
            let currentUser = CookieFactory.getCookie("flexyBeauty-pro-user");
            if (currentUser && currentUser.hasOwnProperty("managerMode")) {
                currentUser.managerMode = $scope.ad.managerMode;
                CookieFactory.setCookie('flexyBeauty-pro-user', currentUser);
            }
        };

        $scope.$watch("ad.managerMode", function(newValue, oldValue) {
            const timer = $timeout(function() {
                if ($scope.isAccessBackofficeCustomer) {
                    $scope.navigateToNgApp({name: Constants.ANGULAR_EVENTS.MANAGER_MODE, value: $scope.ad.managerMode});
                    $scope.updateManagerModeCookie();
                }
            });
            timers.push(timer);
        });

        $scope.openDeletedCustomerViewConfirmDialog = function() {
            if ($scope.dd.edited.customerView) {
                let opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            let tableModel = [];
                            tableModel["label"] = $scope.dd.edited.customerView.label;
                            return tableModel;
                        }}};

                let d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result)
                        $scope.removeEditedCustomerView();
                });

            }
        };

        $scope.emptyGarbage = function() {
            let msgQuestion = gettextCatalog.getString("Voulez-vous vraiment vider la corbeille");
            let msgDescription = gettextCatalog.getString("Uniquement les clients sans rendez-vous, tickets ou chèques seront supprimés");
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        tableModel["question"] = msgQuestion+"?";
                        tableModel["description"] = msgDescription+".";
                        return tableModel;
                    }}};

            let d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    let msgLabel = gettextCatalog.getString("La fonction d'envoie s'exécute sur le serveur et peut prendre jusqu'à 10 minutes. Il faudra ensuite actualiser pour constater le résultat");
                    CustomerSrv.emptyGarbage();
                    opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["label"] = msgLabel+".";
                                return tableModel;
                            }}};

                    $dialog.dialog(opts).open();
                }
            });
        };

        $scope.addCustomersViewDisplayed = function(customerView) {
            if (customerView && $scope.dd.view.customersViewDisplayed.indexOf(customerView) === -1) {
                if(!customerView.isHistoryInit) {
                    customerView.initCustomerHistoryDatas(customerView.getModel())
                }
                $scope.dd.view.customersViewDisplayed.push(customerView);
            }
        };

        $scope.addMoreCustomersView = function() {
            if ((!$scope.dd.view.customerFilter || $scope.dd.view.customerFilter.length < 2)
                && !$scope.dd.view.customerFilterBirthday) {
                if ($scope.dd.view.customersViewDisplayed && $scope.dd.view.customersView) {
                    let initSize = $scope.dd.view.customersViewDisplayed.length;
                    for (let i = initSize; i < $scope.dd.view.customersView.length && i < (initSize + 20); i++) {
                        $scope.addCustomersViewDisplayed($scope.dd.view.customersView[i]);
                    }
                    $scope.onChangeCustomerFilter($scope.customersFilterValue, initSize + 20);
                }
            } else {
                $scope.onChangeCustomerFilter($scope.customersFilterValue);
            }
        };

        $scope.addMoreCustomersDeletedView = function() {
            if ($scope.dd.view.customersDeletedViewDisplayed) {
                let initSize = $scope.dd.view.customersDeletedViewDisplayed.length;
                for(let i = initSize; i < $scope.dd.view.customersDeletedView.length && i < (initSize + 20); i++)
                    $scope.dd.view.customersDeletedViewDisplayed.push($scope.dd.view.customersDeletedView[i]);
            }
        };

        $scope.getCfgClass = function(confItem,className) {
            if (confItem == $scope.dd.displaySubConf) {
                return className;
            }
            return "";
        };

        $scope.setEditedCustomerView = function(customerView) {
            if ($scope.dd.edited.customerView && $scope.dd.edited.customerView !== customerView) {
                $scope.dd.edited.customerView.reloadModel();
            } else if(customerView && !customerView.isHistoryInit) {
                customerView.initCustomerHistoryDatas(customerView.getModel());
            }
            $scope.myMargintop = 75;

            $scope.dd.edited.customerView = customerView;
        };

        $scope.createCustomer = function() {
            let newCustomerView = new CustomerView(null, -1, $scope.dd.view);
            $scope.dd.view.customersViewDisplayed.splice(0, 0, newCustomerView);//Insert in first place
            $scope.dd.view.customersView.splice(0, 0, newCustomerView);//Insert in first place
            $scope.dd.edited.customerView = newCustomerView;
            $scope.myMargintop = 75;
        };

        $scope.setCurrentCategory = function(categoryView) {
            $scope.dd.view.cCategoryView = categoryView;
        };

        $scope.setCurrentProductCategory = function (categoryView) {
            $scope.dd.view.cProductCategoryView = categoryView;
        };

        $scope.setCurrentCureCategory = function (categoryView) {
            $scope.dd.view.cCureCategoryView = categoryView;
        };

        $scope.setCurrentLoyaltyCategory = function (categoryView) {
            $scope.dd.view.cLoyaltyCardCategoryView = categoryView;
        };

        $scope.cancelEditedCustomerView = function() {
            if ($scope.dd.edited.customerView.cIndex!=-1) {// retrieve old value from server
                $scope.dd.edited.customerView.reloadModel();
            } else {
                let index = $scope.dd.view.customersView.indexOf($scope.dd.edited.customerView);
                if (index !== 1) {
                    $scope.dd.view.customersView.splice(index, 1);
                }
                index = $scope.dd.view.customersViewDisplayed.indexOf($scope.dd.edited.customerView);
                if (index !== 1) {
                    $scope.dd.view.customersViewDisplayed.splice(index,1);
                }
            }
            $scope.dd.edited.customerView = null;
            $scope.dd.displayError = false;
            $scope.myMargintop = 40;
        };

        $scope.saveEditedCustomerView = function() {
            if ($scope.dd.edited.customerView) {
                let isNew = $scope.dd.edited.customerView.getModel()==null;//Is a new : sort
                $scope.dd.edited.customerView.updateModel();
                if (isNew) {
                    $scope.dd.edited.customerView.createInterNationalAndNationalPhoneFormat();
                    $scope.dd.view.customersView = $filter('orderBy')($scope.dd.view.customersView, 'label');//TODO OPTIMIZE
                    $scope.dd.view.customersViewDisplayed = $filter('orderBy')($scope.dd.view.customersViewDisplayed, 'label');//TODO OPTIMIZE
                    let index =  $scope.dd.view.customersView.indexOf($scope.dd.edited.customerView);
                    if (index >=$scope.dd.view.customersViewDisplayed.length) {//Must remove from displayed because it's out of current array
                        index =  $scope.dd.view.customersViewDisplayed.indexOf($scope.dd.edited.customerView);
                        if (index !== 1)
                            $scope.dd.view.customersViewDisplayed.splice(index,1);
                    }
                }

            }
            $scope.dd.displayError = false;
            $scope.dd.edited.customerView = null;
            $scope.myMargintop = 40;

        };
        $scope.removeEditedCustomerView = function() {
            if ($scope.dd.edited.customerView) {
                $scope.dd.edited.customerView.removeModel();
                let index = $scope.dd.view.customersView.indexOf($scope.dd.edited.customerView);
                if (index !== -1) {
                    if ($scope.dd.view.customersDeletedView) {
                        $scope.dd.view.customersDeletedView.push($scope.dd.edited.customerView);
                        $scope.dd.view.customersDeletedViewDisplayed.push($scope.dd.edited.customerView);
                    }
                    $scope.dd.view.customersView.splice(index,1);
                }
                index = $scope.dd.view.customersViewDisplayed.indexOf($scope.dd.edited.customerView);
                if (index !== -1) {
                    $scope.dd.view.customersViewDisplayed.splice(index,1);
                }
            }
            $scope.dd.edited.customerView = null;
            $scope.myMargintop = 40;
        };

        $scope.restore = function(customerView) {
            if (customerView) {
                if (customerView.cIndex !== -1) {
                    customerView.restoreModel();
                }
                let index = $scope.dd.view.customersDeletedView.indexOf(customerView);
                if (index !== -1) {
                    $scope.dd.view.customersDeletedView.splice(index, 1);
                    if ($scope.dd.view.customersView) {
                        $scope.dd.view.customersView.push(customerView)
                    }
                }
            }
        };

        $scope.exportExcelCustomer = function(object, id, title){
            let timeout = $scope.dd.view.customersView.length > 3000 ? $scope.dd.view.customersView.length : 3000;
            $scope.createCustomerTable(true, 'table-customers-hide');
            const timer = $timeout(function(){$('#'+id).remove();}, timeout);
            timers.push(timer);

            return ExcellentExport.excel(object, id, title);
        };

        $scope.exportCsvCustomer = function(object, id){
            let timeout = $scope.dd.view.customersView.length > 3000 ? ($scope.dd.view.customersView.length) : 3000;
            $scope.createCustomerTable(true, 'table-customers-hide');
            const timer = $timeout(function(){$('#'+id).remove();}, timeout);
            timers.push(timer);
            return ExcellentExport.csv(object, id, ';');
        };

        $scope.createCustomerTable = function(isExport, divId){
            let firstDate;
            let lastDate;
            let firstSaleDate;
            let lastSaleDate;
            let nbClient=0;
            let maxCustomerDisplay = 5000;
            let content = "";
            let tableId = "table-customers-export";

            let labelLastName = gettextCatalog.getString("Nom"),
                labelFirstName = gettextCatalog.getString("Prénom"),
                labelGenre = gettextCatalog.getString("Genre"),
                labelEmail = gettextCatalog.getString("E-mail"),
                labelMobilePhone = gettextCatalog.getString("Tél. portable"),
                labelPhone = gettextCatalog.getString("Tél. Fixe"),
                labelAddress = gettextCatalog.getString("Adresse"),
                labelZipCode = gettextCatalog.getString("Code postal"),
                labelCity = gettextCatalog.getString("Ville"),
                labelOrigin = gettextCatalog.getString("Origine"),
                labelBirthday = gettextCatalog.getString("Date de naissance"),
                labelComments = gettextCatalog.getString("Commentaire"),
                labelBReservation = gettextCatalog.getString("Nb Rdvs"),
                labelRdvKo = gettextCatalog.getString("Nb Rdvs - Pas venu"),
                labelRdvOk = gettextCatalog.getString("Nb Rdvs - Venu"),
                labelWaitingTickets = gettextCatalog.getString("Nb tickets en attente"),
                labelTickets = gettextCatalog.getString("Nb tickets encaissés"),
                labelCures = gettextCatalog.getString("Nb cures restantes"),
                labelBons = gettextCatalog.getString("Nb bons restants"),
                labelTotal = gettextCatalog.getString("Total encaissé"),
                labelFirstVisitDate = gettextCatalog.getString("Date première visite"),
                labelLastVisitDate = gettextCatalog.getString("date dernière visite"),
                labelFirstBuy = gettextCatalog.getString("date premier achat"),
                labelLastBuy = gettextCatalog.getString("date dernier achat"),
                isSmsAllowed = gettextCatalog.getString("Campagne SMS OK"),
                isMailAllowed = gettextCatalog.getString("Campagne EMAIL OK"),
                isNotifAllowed = gettextCatalog.getString("Campagne Notification OK"),
                unknowValue = gettextCatalog.getString("Non renseigné"),
                yes = gettextCatalog.getString("Oui"),
                no = gettextCatalog.getString("Non");

            if(isExport){
                tableId = "table-customers-export-hide";
                content +="<div id=\"table-customers-hide\" style=\"display:none;\">";
            }

            content +="<table id=\""+tableId+"\" class=\"table even-color fxb-table\"><tr> <th>Nb : "+ $scope.dd.view.customersViewDisplayed.length +
                "</th> <th >"+labelLastName+"</th> <th >"+labelFirstName+"</th> <th >"+labelGenre+"</th> <th >"+labelEmail+"</th> <th >"+labelMobilePhone+"</th> <th>"+labelPhone+"</th><th >"+labelAddress+"</th><th >"+labelZipCode+"</th>" +
                "<th >"+labelCity+"</th><th >"+labelOrigin+"</th><th >"+labelBirthday+"</th> <th >"+labelComments+"</th><th >"+labelBReservation+"</th><th >"+labelRdvKo+"</th><th >"+labelRdvOk+"</th>" +
                "<th >"+labelWaitingTickets+"</th><th >"+labelTickets+"</th><th >"+labelCures+" </th><th >"+labelBons+"</th><th >"+labelTotal+"</th>" +
                "<th >"+labelFirstVisitDate+"</th><th >"+labelLastVisitDate+"</th><th >"+labelFirstBuy+"</th><th >"+labelLastBuy+"</th><th >"+isSmsAllowed+"</th><th >"+isMailAllowed+"</th><th >"+isNotifAllowed+"</th></tr>";
            let date = new Date();
            $scope.dd.view.customersView.sort(dynamicSort($scope.customersSortValue,$scope.customersOrderByReverse?-1:1))
            let customersToDisplay = [];
            if(!isExport && maxCustomerDisplay && $scope.dd.view.customersView.length > maxCustomerDisplay){
                customersToDisplay = $scope.dd.view.customersView.slice(0, maxCustomerDisplay);
            }
            else{
                customersToDisplay = $scope.dd.view.customersView;
            }

            for(let i = 0; i < customersToDisplay.length; i++) {
                if ($scope.customersFilterValue===''
                    || ($scope.customersFilterValue===$scope.customerFilterModes.filterByBirthday && customersToDisplay[i].birthDate && customersToDisplay[i].birthDate.getMonth() === date.getMonth())
                    || (customersToDisplay[i].gender === $scope.customersFilterValue)
                ) {
                    firstSaleDate = null;
                    lastSaleDate = null;
                    if (customersToDisplay[i].globalHistoryView && customersToDisplay[i].globalHistoryView.length > 0) {
                        lastDate = customersToDisplay[i].globalHistoryView[0].date;
                        firstDate = customersToDisplay[i].globalHistoryView[customersToDisplay[i].globalHistoryView.length - 1].date;

                        for (let j = 0; j < customersToDisplay[i].globalHistoryView.length; j++) {
                            if (customersToDisplay[i].globalHistoryView[j].status === "sold" && customersToDisplay[i].globalHistoryView[j].date) {
                                if (lastSaleDate == null || lastSaleDate.getTime() < customersToDisplay[i].globalHistoryView[j].date.getTime())
                                    lastSaleDate = customersToDisplay[i].globalHistoryView[j].date;
                                if (firstSaleDate == null || firstSaleDate.getTime() > customersToDisplay[i].globalHistoryView[j].date.getTime())
                                    firstSaleDate = customersToDisplay[i].globalHistoryView[j].date;
                            }
                        }
                    } else {
                        firstDate = null;
                        lastDate = null;
                    }
                    content += '<tr><td>' + (++nbClient) + '</td>' +
                        '<td>' + (customersToDisplay[i].lastName ? customersToDisplay[i].lastName : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].firstName ? customersToDisplay[i].firstName : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].gender ? customersToDisplay[i].gender : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].email ? customersToDisplay[i].email : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].phoneDisplay ? customersToDisplay[i].phoneDisplay : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].landline ? customersToDisplay[i].landline : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].address1 ? customersToDisplay[i].address1 : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].postCode ? customersToDisplay[i].postCode : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].city ? customersToDisplay[i].city : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].origin ? customersToDisplay[i].origin : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].birthDate ? $filter('date')(customersToDisplay[i].birthDate, 'shortDate') : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].comment ? customersToDisplay[i].comment : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].historyBookingsView ? customersToDisplay[i].historyBookingsView.length : '') + '</td>' +
                        '<td>' + (customersToDisplay[i].nbNotCameBookings) + '</td>' +
                        '<td>' + (customersToDisplay[i].nbCameBookings) + '</td>' +
                        '<td>' + (customersToDisplay[i].nbWaitingSales) + '</td>' +
                        '<td>' + (customersToDisplay[i].nbSoldSales ) + '</td>' +
                        '<td>' + (customersToDisplay[i].nbCureItemNotUsed ) + '</td>' +
                        '<td>' + (customersToDisplay[i].nbGiftItemsNotUsed ) + '</td>' +
                        '<td>' + ( $filter('number')(customersToDisplay[i].historySoldPrice, 2) ) + '</td>' +
                        '<td>' + (firstDate ? $filter('date')(firstDate, 'shortDate') : '') + '</td>' +
                        '<td>' + (lastDate ? $filter('date')(lastDate, 'shortDate') : '') + '</td>' +
                        '<td>' + (firstSaleDate ? $filter('date')(firstSaleDate, 'shortDate') : '') + '</td>' +
                        '<td>' + (lastSaleDate ? $filter('date')(lastSaleDate, 'shortDate') : '') + '</td>'+
                        '<td>' + (customersToDisplay[i].optInOutView.isAgreementKnown() ? (customersToDisplay[i].optInOutView.isSmsCampaignAllowed ? yes:no) : unknowValue) + '</td>' +
                        '<td>' + (customersToDisplay[i].optInOutView.isAgreementKnown() ? (customersToDisplay[i].optInOutView.isEmailCampaignAllowed ? yes:no) : unknowValue) + '</td>' +
                        '<td>' + (customersToDisplay[i].optInOutView.isAgreementKnown() ? (customersToDisplay[i].optInOutView.isNotificationCampaignAllowed ? yes:no) : unknowValue) + '</td></tr>';
                }
            }
            if(!isExport && customersToDisplay.length == maxCustomerDisplay){
                content += '<tr><td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td>' +
                    '<td>...</td></tr>';

            }

            if(isExport){
                tableId = "table-customers-export-hide";
                content +="</div>"
            }
            content += "</table>";
            $("#"+divId).replaceWith(content);
            $("#"+ tableId + " th:first-child")[0].innerText="Nb :"+nbClient;
        };


        $scope.orderCustomersView = function(){
            if($scope.cutomerTabNeedToOrder){
                $scope.dd.view.customersView = $filter("orderBy")($scope.dd.view.customersView, $scope.customersSortValue, $scope.customersOrderByReverse);
                $scope.cutomerTabNeedToOrder = false;
            }
        };

        $scope.onChangeCustomerFilter = function(filter, nbCustomersDisplayed){
            if($scope.dd.view.customersView){
                $scope.orderCustomersView();
                $scope.customersFilterValue = filter;
                if ($scope.dd.displayTable){
                    $scope.loadAllCustomerViewsHistory(function() {
                        $scope.setEditedCustomerView(null);
                        const timer = $timeout(function (){
                            $scope.createCustomerTable(false, 'table-customers-export');

                        }, 200);
                        timers.push(timer);
                    });
                }
                else{
                    let date = new Date();
                    let customerFilter = $scope.dd.view.customerFilter;
                    let customerFilterModes = $scope.customerFilterModes;
                    if (!customerFilter || customerFilter.length < 2){ //No filter : reset array to initial size

                        let nbCustomersOnScreen = 20;
                        if (nbCustomersDisplayed != null && !isNaN(nbCustomersDisplayed) && nbCustomersDisplayed > 0){
                            nbCustomersOnScreen = nbCustomersDisplayed;
                        }
                        if ($scope.dd.displayTable)
                            nbCustomersOnScreen = $scope.dd.view.customersView.length;

                        $scope.dd.view.customersViewDisplayed = [];

                        if ($scope.customersFilterValue === customerFilterModes.filterByBirthday){
                            for (let i = 0; i < $scope.dd.view.customersView.length; i++){
                                let customersView = $scope.dd.view.customersView[i];
                                if (customersView.birthDate && customersView.birthDate.getMonth() === date.getMonth())
                                    $scope.addCustomersViewDisplayed(customersView);
                            }
                        }
                        else if ($scope.customersFilterValue === customerFilterModes.filterByChildGender ||
                            $scope.customersFilterValue === customerFilterModes.filterByManGender ||
                            $scope.customersFilterValue === customerFilterModes.filterByWomanGender){
                            for (let i = 0; i < $scope.dd.view.customersView.length; i++){
                                let customersView = $scope.dd.view.customersView[i];
                                if (customersView.gender === $scope.customersFilterValue)
                                    $scope.addCustomersViewDisplayed(customersView);
                            }
                        }
                        else
                            for (let i = 0; i < $scope.dd.view.customersView.length && i < nbCustomersOnScreen; i++){
                                let customersView = $scope.dd.view.customersView[i];
                                $scope.addCustomersViewDisplayed(customersView);
                            }
                    }
                    else{
                        $scope.dd.view.customerFilterBirthday = false;
                        let start = 0;
                        let newMaxLength = $scope.dd.view.customersViewDisplayed.length + 20;
                        //Add elements to array
                        if (customerFilter.length === 0){
                            if ($scope.dd.view.customersViewDisplayed.length !== 0){
                                //start using first index of new element
                                start = $scope.dd.view.customersView.indexOf($scope.dd.view.customersViewDisplayed[$scope.dd.view.customersViewDisplayed.length - 1]) + 1;
                            }
                        }
                        else{
                            $scope.dd.view.customersViewDisplayed = [];
                        }
                        let filterWithoutSpace = customerFilter.replace(/\s/g, '');

                        for (let i = start; i < $scope.dd.view.customersView.length && $scope.dd.view.customersViewDisplayed.length < newMaxLength; i++){
                            let customersView = $scope.dd.view.customersView[i];

                            if (($scope.customersFilterValue === '' ||
                                ($scope.customersFilterValue === customerFilterModes.filterByBirthday && customersView.birthDate && customersView.birthDate.getMonth() === date.getMonth()) ||
                                ($scope.customersFilterValue === customerFilterModes.filterByManGender && customerFilterModes.filterByManGender === customersView.gender) ||
                                ($scope.customersFilterValue === customerFilterModes.filterByWomanGender && customerFilterModes.filterByWomanGender === customersView.gender) ||
                                ($scope.customersFilterValue === customerFilterModes.filterByChildGender && customerFilterModes.filterByChildGender === customersView.gender)) &&
                                ((customersView.lastName && customersView.lastName.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0) ||
                                    (customersView.email && customersView.email.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0) ||
                                    (customersView.firstName && customersView.firstName.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0) ||
                                    (customersView.label && customersView.label.toLowerCase().indexOf(customerFilter.toLowerCase()) === 0) ||
                                    (customersView.phone && customersView.customerInterNationalLandlineNumber && customersView.customerInterNationalLandlineNumber.indexOf(filterWithoutSpace) === 0) ||
                                    (customersView.phone && customersView.customerNationalLandlineNumber && customersView.customerNationalLandlineNumber.indexOf(filterWithoutSpace) === 0) ||
                                    (customersView.phone && customersView.customerInterNationalMobileNumber && customersView.customerInterNationalMobileNumber.indexOf(filterWithoutSpace) === 0) ||
                                    (customersView.phone && customersView.customerNationalMobileNumber && customersView.customerNationalMobileNumber.indexOf(filterWithoutSpace) === 0))
                            ){
                                $scope.addCustomersViewDisplayed(customersView);
                            }
                        }
                    }
                }
            }
        };

        $scope.onChangeCustomerOrder = function(sortMode, sortOrder){
            $scope.customersSortValue = sortMode;
            $scope.customersOrderByReverse = sortOrder;
            $scope.cutomerTabNeedToOrder = true;
            $scope.loadAllCustomerViewsHistory();
            $scope.onChangeCustomerFilter($scope.customersFilterValue);
        };

        let dynamicSort = function (property, sortOrder) {
            return function (a, b) {
                let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        };

        //FIX ME: UNUSED FUNCTION
        $scope.displayError = function () {
            $scope.dd.displayError = true;
            $scope.dd.displayPhoneError = !($scope.dd.edited.customerView && $scope.dd.edited.customerView.hasValidCellPhone(false));
            $scope.dd.displayLandlineError = !($scope.dd.edited.customerView && $scope.dd.edited.customerView.hasValidLandLine());
        };

        $scope.onExternalOptInOutChange = function(){
            if(!$scope.dd.edited.customerView.optInOutView.isAgreementKnown()){
                $scope.dd.edited.customerView.optInOutView.isSmsCampaignAllowed = true;
                $scope.dd.edited.customerView.optInOutView.origin = '';
                $scope.dd.edited.customerView.optInOutView.isNotificationCampaignAllowed = true;
                $scope.dd.edited.customerView.optInOutView.isEmailCampaignAllowed = true;
                $scope.dd.edited.customerView.optInOutView.timeModified = new Date();
                $scope.dd.edited.customerView.optInOutView.updateDateString();
            }
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/planningPos/customer/customerExternalOptInOut.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        let tableModel = [] ;
                        tableModel["customerView"] = $scope.dd.edited.customerView;
                        return tableModel;
                    }
                }};

            let d = $dialog.dialog(opts);
            d.open().then(function(result){
                if (result)
                {
                    $scope.dd.edited.customerView.optInOutView.isExternalOptInOut = true;
                    if($scope.dd.edited.customerView.getModel())
                        $scope.dd.edited.customerView.optInOutView.updateModel(null, null, $scope.dd.edited.customerView.getModel().getId());
                    else
                        $scope.dd.edited.customerView.optInOutView.updateModel();
                }
                else{
                    if($scope.dd.edited.customerView.optInOutView.getModel()){
                        $scope.dd.edited.customerView.optInOutView.loadDataFrom($scope.dd.edited.customerView.optInOutView.getModel())
                    }
                    else{
                        $scope.dd.edited.customerView.optInOutView = new OptInOutView(null, -1);
                    }
                }
            });
        };

        $scope.fusionCustomers = function(customerSourceView,customerTargetView) {
            if (customerSourceView && customerTargetView)
            {
                let customerSource = customerSourceView.getModel();
                let customerTarget = customerTargetView.getModel();
                if (customerSource && customerTarget)
                    {
                        CustomerSrv.fusion(customerSource,customerTarget, function () {
                            let targetActiveLoyaltyCard = $scope.getActiveLoyaltyCard(customerTarget);

                            for (let i = 0; i < BookingData.indexBookings.length; i++) {
                                let booking = BookingData.indexBookings[i];
                                if (booking && booking.customer === customerSource) {
                                    customerSource.removeBooking(booking);

                                    if(booking.sale){
                                        booking.sale.inactiveUnusedLoyaltyCardItem(targetActiveLoyaltyCard);
                                        booking.sale.inactiveUnusedLoyaltyCardItems(targetActiveLoyaltyCard);
                                    }

                                    customerTarget.addBooking(booking);
                                    booking.customer = customerTarget;
                                }
                            }

                            for (let i = 0; i < SaleData.indexSales.length; i++) {
                                let sale = SaleData.indexSales[i];
                                if (sale && sale.customer === customerSource) {
                                    sale.inactiveUnusedLoyaltyCardItem(targetActiveLoyaltyCard);
                                    sale.inactiveUnusedLoyaltyCardItems(targetActiveLoyaltyCard);
                                    customerSource.removeSale(sale);
                                    customerTarget.addSale(sale);
                                    sale.customer = customerTarget;
                                }
                            }

                            for (let i = 0; i < GiftItemData.indexGiftItems.length; i++) {
                                let giftItem = GiftItemData.indexGiftItems[i];
                                if (giftItem && giftItem.customer === customerSource) {
                                    customerSource.removeGiftItem(giftItem);

                                    if(giftItem.sale){
                                        giftItem.sale.inactiveUnusedLoyaltyCardItem(targetActiveLoyaltyCard);
                                        giftItem.sale.inactiveUnusedLoyaltyCardItems(targetActiveLoyaltyCard);
                                    }

                                    customerTarget.addGiftItem(giftItem);
                                    giftItem.customer = customerTarget;
                                }
                            }

                            for (let i = 0; i < CureItemData.indexCureItems.length; i++) {
                                let cureItem = CureItemData.indexCureItems[i];

                                if (cureItem.customer === customerSource) {
                                    cureItem.customer = customerTarget;
                                }
                            }

                            $scope.updateCustomerAttributes(customerSource, customerTarget);
                            CustomerData.remove(customerSource);
                            $scope.ad.loading = true;
                            $route.reload();

                        }, function (data){
                            if((data == null) || data.status == null || data.status !== "200"){
                                $scope.dd.view.display.fusionCustomersError = true;
                            }
                        });
                    }
                }

            };
            $scope.getActiveLoyaltyCard = function(customer){
                let activeLoyaltyCardItem = null;
                for (let i = 0; i < customer.sales.length; i++) {
                    let sale = customer.sales[i];

                    if (sale && sale.loyaltyCardItem && !sale.loyaltyCardItem.isUsed) {
                        activeLoyaltyCardItem = sale.loyaltyCardItem;
                        break;
                    }
                }
                return activeLoyaltyCardItem;
            };
            $scope.updateCustomerAttributes = function (customerSource, customerTarget) {

                if (!customerTarget.phone) {
                    customerTarget.phone = customerSource.phone;
                }

                if (!customerTarget.landline){
                    customerTarget.landline = customerSource.landline;
                }

                if (!customerTarget.email){
                    customerTarget.email = customerSource.email;
                }

                if (!customerTarget.comment) {
                    customerTarget.comment = customerSource.comment;
                }

                if (!customerTarget.gender){
                    customerTarget.gender = customerSource.gender;
                }

                if (!customerTarget.isVerified){
                    customerTarget.isVerified = customerSource.isVerified;
                }

                if (!(customerTarget.address1 && customerTarget.city && customerTarget.postCode)){
                    customerTarget.address1 = customerSource.address1;
                    customerTarget.postCode = customerSource.postCode;
                    customerTarget.city = customerSource.city;
                }

                if (!customerTarget.origin){
                    customerTarget.origin = customerSource.origin;
                }

                if (!customerTarget.online){
                    customerTarget.online = customerSource.online;
                }

                if (!customerTarget.birthDate){
                    customerTarget.birthDate = customerSource.birthDate;
                }

                if (!customerTarget.isCGVAccepted){
                    customerTarget.isCGVAccepted = customerSource.isCGVAccepted;
                }

                if (!customerTarget.optInOut){
                    customerTarget.optInOut = customerSource.optInOut;
                }
            };

            $scope.openFusionCustomerViewConfirmDialog = function() {
                if ($scope.dd.edited.customerView) {
                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/planningPos/customer/customerFusion.html',
                        controller: 'CustomerFusionCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["sourceCustomerView"] = $scope.dd.edited.customerView;
                                tableModel["dd"] = $scope.dd;
                                return tableModel;
                            }}};

                    let d = $dialog.dialog(opts);
                    d.open().then(function (customerTarget) {
                        if (customerTarget)
                            $scope.fusionCustomers($scope.dd.edited.customerView,customerTarget);
                    });
                }
            };

            $scope.$on('$destroy', function () {
                goToDomainCalledDestroy();

                Timers.cancel(timers);
            });
}]);



// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/customerCtrl.js